module.exports = __webpack_public_path__ + "static/img/img_holder_off.5467eac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_holder_off.png
// module id = 722
// module chunks = 1